import {Injectable} from '@angular/core';
import {CanDeactivate} from '@angular/router';
import {ICanComponentDeactivate} from './i-can-component-deactivate';

@Injectable()
export class CanDeactivateGuard implements CanDeactivate<ICanComponentDeactivate> {

  canDeactivate(component: ICanComponentDeactivate) {
    return component.canDeactivate ? component.canDeactivate() : true;
  }

}
